import React, { useState } from "react";
import "../dev_profile/dev_profile.css";
import { Btn, FormInput, SuccessComp } from "../../utils/utils";
import { AxiosAuthPost } from "../../api/api";

const AgentSec = () => {
  const url = `agent/profile/change-password`;
  const [isLoading, setIsLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState(false);

  const [data, setData] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [dataErr, setDataErr] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const dataChange = (e) => {
    const newData = { ...data };
    newData[e.target.id] = e.target.value;
    setData(newData);
    const newDataErr = { ...dataErr };
    newDataErr[e.target.id] = "";
    setDataErr(newDataErr);
    if (newData?.newPassword !== newData?.confirmPassword) {
      setDataErr({ ...dataErr, confirmPassword: "Passwords don't match" });
    }
    // console.log(newData);
  };

  const dataObj = {
    currentPassword: data?.currentPassword,
    newPassword: data?.newPassword,
  };

  const editPassword = () => {
    setIsLoading(true);
    AxiosAuthPost(url, dataObj)
      .then((res) => {
        // console.log(res);
        setSuccessMsg(res.message);
        setData({
          currentPassword: "",
          newPassword: "",
          confirmPassword: "",
        });
        setTimeout(() => {
          setSuccessMsg("");
        }, 2000);
        setIsLoading(false);
      })
      .catch((err) => {
        // console.log(err.response);
        for (let i = 0; i < err?.response?.data?.errors?.length; i++) {
          const fieldName = err?.response?.data?.errors[i].fieldName;
          const error = err?.response?.data?.errors[i].error;
          setDataErr((prevErrs) => ({
            ...prevErrs,
            [fieldName]: error,
          }));
        }
        setIsLoading(false);
      });
  };

  return (
    <div>
      <SuccessComp message={successMsg} />
      <div className="dev_prof_body">
        <FormInput
          label={"Current Password"}
          id={"currentPassword"}
          changeInput={dataChange}
          value={data.currentPassword}
          err={dataErr.currentPassword}
          isPassword
        />
        <div className="d_p_b_inp">
          <div className="eac_inp">
            <FormInput
              label={"New Password"}
              id={"newPassword"}
              changeInput={dataChange}
              value={data.newPassword}
              err={dataErr.newPassword}
              isPassword
            />{" "}
          </div>{" "}
          <div className="eac_inp">
            <FormInput
              label={"Confirm Password"}
              id={"confirmPassword"}
              changeInput={dataChange}
              value={data.confirmPassword}
              err={dataErr.confirmPassword}
              isPassword
            />
          </div>
        </div>
        <Btn
          btnClick={editPassword}
          btnText={"Save Changes"}
          btnClass={"home-btn_s"}
          loading={isLoading}
        />
      </div>
    </div>
  );
};

export default AgentSec;
